import { AxiosRequestConfig } from "axios";
import { doApiCall } from "./utils";

const { REACT_APP_REGISTRATION_API_URL } = process.env;

export type UserMfa = {
  mfaEnforcedOnLogin: boolean;
};

export type UserMfaResponse = {
  data: UserMfa;
  meta?: {
    message?: string;
    details?: string;
  };
};

export const getMemberMfaEnforcedStatus = () => {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user/mfa`
  };

  return doApiCall(request);
};

/**
 * Set MFA Enforcement Status for the current user.
 */
export const patchUserMfaEnforcedStatus = (status: boolean) => {
  const payload: UserMfa = { mfaEnforcedOnLogin: status };
  const request: AxiosRequestConfig = {
    method: "PATCH",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user/mfa`,
    data: payload
  };

  return doApiCall(request);
};

/**
 * Enable MFA enforcement for the current user.
 */
export const enableMfa = () => {
  return patchUserMfaEnforcedStatus(true);
};

/**
 * Disable MFA enforcement for the current user.
 */
export const disableMfa = () => {
  return patchUserMfaEnforcedStatus(false);
};
